import Icon from "@ant-design/icons";

const JacuzziSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M363 5105 c-176 -48 -317 -195 -353 -371 -19 -90 -8 -1080 14 -1254
44 -356 124 -676 243 -980 36 -90 43 -117 34 -130 -6 -8 -23 -39 -37 -68 -45
-93 -23 -173 107 -394 l30 -50 -20 -62 c-72 -218 -79 -440 -20 -656 26 -95 94
-239 156 -332 62 -93 198 -229 291 -291 300 -200 649 -248 988 -136 l62 20 50
-30 c124 -73 237 -124 282 -129 56 -5 139 19 165 48 23 25 31 25 96 -4 248
-109 677 -219 1029 -262 174 -22 1164 -33 1254 -14 134 28 270 131 330 248 60
118 56 -46 56 2490 l0 2323 -25 24 -24 25 -2328 -1 c-1970 0 -2336 -2 -2380
-14z m4595 -2427 l-3 -2283 -27 -51 c-40 -76 -70 -107 -140 -145 l-63 -34
-530 0 c-562 0 -640 4 -915 51 -246 42 -522 120 -743 208 l-82 33 -6 44 c-15
104 -58 155 -182 220 -508 264 -970 670 -1305 1149 -79 111 -189 293 -241 398
-59 117 -130 173 -235 184 -26 3 -32 11 -62 85 -82 205 -163 489 -203 708 -52
292 -56 357 -56 935 l0 545 25 50 c43 86 125 154 215 176 17 4 1048 7 2293 8
l2262 1 -2 -2282z m-4438 -398 c10 -5 44 -58 76 -117 182 -341 387 -617 668
-899 282 -281 558 -486 899 -668 59 -32 112 -66 117 -76 27 -51 -11 -120 -66
-120 -29 0 -195 87 -349 182 -450 279 -856 661 -1151 1084 -148 212 -314 502
-314 548 0 55 69 93 120 66z m79 -729 c137 -191 246 -317 445 -517 190 -189
359 -333 534 -454 57 -40 87 -67 80 -71 -27 -17 -187 -31 -278 -26 -237 15
-442 109 -616 281 -171 170 -266 379 -281 617 -6 104 16 304 32 287 2 -2 40
-54 84 -117z"
      />
      <path
        d="M1235 4629 c-142 -24 -270 -92 -381 -203 -90 -90 -143 -176 -182
-294 -22 -68 -25 -98 -30 -270 -9 -392 41 -735 162 -1097 226 -676 703 -1278
1316 -1657 526 -326 1113 -482 1749 -466 166 5 195 8 266 31 114 38 198 90
290 182 91 91 143 174 183 290 l27 80 3 1490 c2 1051 -1 1505 -9 1542 -27 131
-131 268 -247 327 -116 59 -35 56 -1632 55 -806 -1 -1487 -5 -1515 -10z m3073
-188 c70 -38 100 -69 140 -145 l27 -51 0 -1495 c0 -1435 -1 -1497 -19 -1550
-48 -141 -149 -267 -263 -327 -125 -65 -142 -68 -433 -67 -218 1 -291 5 -410
23 -327 49 -602 134 -885 271 -890 434 -1504 1284 -1640 2270 -22 158 -31 554
-16 645 29 171 146 326 304 404 45 22 105 44 132 50 30 5 639 8 1525 7 l1475
-1 63 -34z"
      />
      <path
        d="M1385 3415 c-16 -15 -25 -36 -25 -55 0 -37 39 -80 72 -80 13 0 45
-16 72 -35 84 -59 169 -59 255 0 60 42 72 43 115 10 93 -71 185 -72 280 -4 49
35 60 36 103 3 77 -59 157 -71 198 -29 33 32 33 78 0 110 -13 14 -34 25 -47
25 -13 0 -45 16 -72 35 -84 59 -168 59 -257 0 -28 -19 -57 -35 -64 -35 -7 0
-36 16 -64 35 -89 59 -173 59 -257 0 -27 -19 -55 -35 -63 -35 -8 0 -29 11 -48
26 -77 59 -157 71 -198 29z"
      />
      <path
        d="M2985 2935 c-16 -15 -25 -36 -25 -55 0 -37 39 -80 72 -80 13 0 45
-16 72 -35 84 -59 169 -59 255 0 60 42 72 43 115 10 93 -71 185 -72 280 -4 49
35 60 36 103 3 45 -34 95 -54 138 -54 46 0 85 37 85 80 0 37 -39 80 -72 80
-13 0 -45 16 -72 35 -84 59 -168 59 -257 0 -28 -19 -57 -35 -64 -35 -7 0 -36
16 -64 35 -89 59 -173 59 -257 0 -27 -19 -55 -35 -63 -35 -8 0 -29 11 -48 26
-77 59 -157 71 -198 29z"
      />
      <path
        d="M2185 1895 c-16 -15 -25 -36 -25 -55 0 -37 39 -80 72 -80 13 0 45
-16 72 -35 84 -59 169 -59 255 0 60 42 72 43 115 10 93 -71 185 -72 280 -4 49
35 60 36 103 3 45 -34 95 -54 138 -54 46 0 85 37 85 80 0 37 -39 80 -72 80
-13 0 -45 16 -72 35 -84 59 -168 59 -257 0 -28 -19 -57 -35 -64 -35 -7 0 -36
16 -64 35 -89 59 -173 59 -257 0 -27 -19 -55 -35 -63 -35 -8 0 -29 11 -48 26
-77 59 -157 71 -198 29z"
      />
    </g>
  </svg>
);

const JacuzziIcon = (props) => <Icon component={JacuzziSvg} {...props} />;

export default JacuzziIcon;
